module.exports = __webpack_public_path__ + "static/media/3.2484c9e9.jpg";